import React, { useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Toolbar,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import {
  Home,
  Queue,
  Workspaces,
  GroupAdd,
  School,
  LocalShipping,
  ExpandLess,
  ExpandMore,
  ChevronRight,
  ExitToApp,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { startLogout } from "../../store/auth";

export const AdminDrawer = ({
  activeItem,
  mobileOpen,
  handleDrawerClose,
  drawerWidth,
}: {
  activeItem: string;
  mobileOpen: boolean;
  handleDrawerClose: () => void;
  drawerWidth: number;
}) => {
  const [openSubmenu, setOpenSubmenu] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (activeItem === "EstudiantesTodos" || activeItem === "EstudiantesGrupo") {
      setOpenSubmenu(true);
    }
  }, [activeItem]);

  const handleSubmenuToggle = () => {
    setOpenSubmenu((prev) => !prev);
  };

  const handleLogout = () => {
    dispatch(startLogout());
    navigate("/");
  };

  const renderMenuItem = (
    text: string,
    to: string,
    icon: JSX.Element,
    key: string
  ) => (
    <ListItem disablePadding key={key}>
      <ListItemButton
        onClick={() => navigate(to)}
        selected={activeItem === key}
        sx={{
          backgroundColor: activeItem === key ? "#a6c8fa" : "transparent",
          borderRight: activeItem === key ? "4px solid white" : "4px solid transparent",
          "&:hover": { backgroundColor: "#a6c8fa" },
        }}
      >
        <ListItemIcon sx={{ color: activeItem === key ? "white" : "#fff" }}>
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={text}
          sx={{
            color: activeItem === key ? "white" : "#fff",
            fontWeight: activeItem === key ? "bold" : "normal",
          }}
        />
      </ListItemButton>
    </ListItem>
  );

  return (
    <>
      {/* Drawer para dispositivos móviles */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true, // Mejora el rendimiento en dispositivos móviles
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#4277c2",
            color: "#fff",
          },
        }}
      >
        {renderContent()}
      </Drawer>

      {/* Drawer permanente para escritorio */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#4277c2",
            color: "#fff",
          },
        }}
        open
      >
        {renderContent()}
      </Drawer>
    </>
  );

  function renderContent() {
    return (
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <Box>
          <Box sx={{ p: 2 }}>
            <Typography variant="h6" align="center" sx={{ fontWeight: 700, color: "#fff" }}>
              Academia Mejías
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#ffffff80" }} />
          <List>
            {renderMenuItem("Inicio", "/admin", <Home />, "Inicio")}
            {renderMenuItem("Cursos", "/admin/cursos", <Queue />, "Cursos")}
            {renderMenuItem("Grupos", "/admin/grupos", <Workspaces />, "Grupos")}
            <ListItem disablePadding>
              <ListItemButton onClick={handleSubmenuToggle}>
                <ListItemIcon>
                  <GroupAdd sx={{ color: "#fff" }} />
                </ListItemIcon>
                <ListItemText primary="Estudiantes" sx={{ color: "#fff" }} />
                {openSubmenu ? <ExpandLess sx={{ color: "#fff" }} /> : <ExpandMore sx={{ color: "#fff" }} />}
              </ListItemButton>
            </ListItem>
            <Collapse in={openSubmenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {renderMenuItem("Todos", "/admin/estudiantes", <ChevronRight />, "EstudiantesTodos")}
                {renderMenuItem(
                  "Curso/Grupo",
                  "/admin/estudiantes-curso-grupo",
                  <ChevronRight />,
                  "EstudiantesGrupo"
                )}
              </List>
            </Collapse>
            {renderMenuItem("Colegios", "/admin/colegios", <School />, "Colegios")}
            {renderMenuItem("Sedes Correos", "/admin/sedecorreoscr", <LocalShipping />, "Sedes Correos")}
          </List>
        </Box>
  
        {/* Este Box llena el espacio entre el contenido y el botón de cerrar sesión */}
        <Box sx={{ flexGrow: 1 }} />
  
        {/* Botón de cerrar sesión */}
        <Divider sx={{ borderColor: "#ffffff80" }} />
        <List>
          <ListItem disablePadding>
            <ListItemButton
              onClick={handleLogout}
              sx={{
                backgroundColor: "transparent",
                "&:hover": { backgroundColor: "#a6c8fa" },
              }}
            >
              <ListItemIcon>
                <ExitToApp sx={{ color: "#fff" }} />
              </ListItemIcon>
              <ListItemText primary="Cerrar sesión" sx={{ color: "#fff" }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    );
  }
  
};
